export default {
	title: "Spiritual Guides",
	activeGuidesCount: "Active Guides",
	totalGuidesCount: "Total Guides",
	withMediumsCount: "With Mediums",
	spiritualLine: "Spiritual Line",
	search: "Search guides...",
	edit: "Edit Guide",
	create: "Create Guide",
	deleteConfirmation: "Do you really want to delete the guide {name}?",
	deactivate: "Deactivate",
	deactivateConfirmation: "Deactivate the guide {name}? It will no longer appear in listings, but can be reactivated later.",
	deletePermanent: "Delete permanently",
	deletePermanentConfirmation: "Permanently delete the guide {name}? This action cannot be undone.",
	deletePermanentWarning: "Permanent deletion is only possible if the guide has no links (mediums, attendances, tickets or returns). Otherwise, use the Deactivate option.",
	createSuccess: "Guide created successfully!",
	createError: "Error creating guide",
	primaryMedium: "Primary Medium",
	setPrimary: "Set as Primary",
	primarySetSuccess: "Primary medium set successfully",
	primaryWillReplaceExisting: "When marking as primary, the previous primary medium/guide in the same spiritual line will be automatically unmarked.",
	errorSettingPrimary: "Error setting primary medium",
	confirmRemoveGuide: "Are you sure you want to remove this guide?",
	empty: {
		description: "Register the spiritual guides that work in the temple",
		title: "No spiritual guides found",
	},
	errorActivatingGuide: "Error activating guide",
	errorDeactivatingGuide: "Error deactivating guide",
	errorLoadingAvailableGuides: "Error loading available guides",
	errorLoadingGuides: "Error loading guides",
	errorRemovingGuide: "Error removing guide",
	errorSavingGuide: "Error saving guide",
	guide: "Guide",
	guideActivatedSuccess: "Guide activated successfully",
	guideAddedSuccess: "Guide added successfully",
	guideDeactivatedSuccess: "Guide deactivated successfully",
	guideRemovedSuccess: "Guide removed successfully",
	guideUpdatedSuccess: "Guide updated successfully",
	noGuidesFound: "No guides found",
	primaryGuide: "Primary Guide",
	form: {
		nameLabel: "Guide Name",
		nameHint: "Enter the guide name",
		spiritualLineLabel: "Spiritual Line",
		spiritualLineHint: "Select the spiritual line",
		personLabel: "Person (Optional)",
		personHint: "Select a person associated with the guide",
		primaryMediumLabel: "Primary Medium",
		willBePrimaryMedium: "This person will be automatically set as the primary medium for the guide",
		descriptionLabel: "Description",
		descriptionHint: "Description about the guide",
		isActiveLabel: "Active guide",
		associatedPersonHint: "This person is already associated with the guide and cannot be changed",
		associatedPersonTooltip: "To change the associated person, use the guide's person management",
		isPrimaryLabel: "Primary medium",
		noPersonFound: "No person found",
		personSearchPlaceholder: "Type to search for a person...",
	},
	filter: {
		all: "All",
		active: "Active",
		inactive: "Inactive",
	},
	validation: {
		nameRequired: "Name is required",
		nameMaxLength: "Name must have at most 100 characters",
		spiritualLineRequired: "Spiritual line is required",
		descriptionMaxLength: "Description must have at most 500 characters",
	},
	tabs: {
		overview: "Overview",
		persons: "Persons",
	},
	details: {
		basicInfo: "Basic Information",
		noPeopleAssociated: "No people associated with this guide",
		totalPeople: "Total People",
		activePeople: "Active People",
		totalConsultations: "Consultations",
	},
	messages: {
		loading: "Loading guide...",
		created: "Guide {name} created successfully",
		updated: "Guide {name} updated successfully",
		deleted: "Guide {name} deleted successfully",
		deactivated: "Guide {name} deactivated successfully",
		deletedPermanent: "Guide {name} permanently deleted",
		createError: "Error creating guide",
		updateError: "Error updating guide",
		deleteError: "Error deleting guide",
		deactivateError: "Error deactivating guide",
		deletePermanentError: "Error permanently deleting guide",
	},
	errors: {
		invalidId: "Invalid guide ID",
		fetchError: "Error loading guide data",
	},
};
